import React from 'react';

import { ClassroomDrawer } from '../Components';

import Tab from './Tab';

const CourseDocumentPanel = ({
  toggleComponent,
  onToggleComponentClick,
  drawerProps,
  title,
  tabItems,
  ...restProps
}) => {
  return (
    <ClassroomDrawer
      drawerProps={drawerProps}
      title={title}
      toggleComponent={toggleComponent}
      onToggleComponentClick={onToggleComponentClick}
    >
      <Tab items={tabItems} {...restProps} />
    </ClassroomDrawer>
  );
};

CourseDocumentPanel.propTypes = {
  ...ClassroomDrawer.propTypes,
  ...Tab.propTypes,
};

export default CourseDocumentPanel;
